'use client';

import { useCallback } from 'react';

// Color token map - replaces Chakra's useToken
const TOKEN_MAP: Record<string, string> = {
  'blue.100': '#bee3f8',
  'blue.200': '#90cdf4',
  'yellow.300': '#f6e05e',
  'gray.200': '#e2e8f0',
  'gray.300': '#cbd5e0',
  'gray.400': '#a0aec0',
  'gray.500': '#718096',
  'white': '#ffffff',
  'black': '#000000',
  'blackAlpha.100': 'rgba(0, 0, 0, 0.06)',
  'blackAlpha.400': 'rgba(0, 0, 0, 0.24)',
  'blackAlpha.900': 'rgba(0, 0, 0, 0.92)',
  'whiteAlpha.200': 'rgba(255, 255, 255, 0.08)',
  'whiteAlpha.500': 'rgba(255, 255, 255, 0.36)',
};

export function resolveToken(token: string): string {
  return TOKEN_MAP[token] || token;
}

// Replaces Chakra's useColorModeValue
export function useColorModeValue(light: string, dark: string): string {
  if (typeof document === 'undefined') return dark;
  const theme = document.documentElement.getAttribute('data-theme');
  return theme === 'light' ? light : dark;
}

// Replaces useToken('colors', useColorModeValue(...))
export function useThemedToken(lightToken: string, darkToken: string): string {
  const token = useColorModeValue(lightToken, darkToken);
  return resolveToken(token);
}
